import './tickSection.css'

function TickSection() {
    return (
        <section className="tickSection-container">
            <article className="tick-article">
                <span className="tick-icon"></span>
                <p className='tick-p'>
                    Fluorfri Valla
                </p>
            </article>
            <article className="tick-article">
                <span className="tick-icon"></span>
                <p className='tick-p'>
                    Utbildad Skidtekniker
                </p>
            </article>
            <article className="tick-article">
                <span className="tick-icon"></span>
                <p className='tick-p'>
                    Professionell Service
                </p>
            </article>
            <article className="tick-article">
                <span className="tick-icon"></span>
                <p className='tick-p'>
                    Först Klassigt Resultat
                </p>
            </article>
        </section>
    );
}

export default TickSection